import { h, Fragment, useState } from 'preact';
import { formatMoney } from 'utils/format-money';
import { useProduct } from './product-context';
import Reviews from './yotpo-reviews';
import Rewards from './yotpo-rewards';

const Price = () => {
  const { activeVariant, activeProduct, hasChanged } = useProduct();
  const variantPrice = activeVariant.price.amount * 100;
  const variantCompareAtPrice = activeVariant.compareAtPrice
    ? activeVariant.compareAtPrice.amount * 100
    : null;
  const badgeTag = activeProduct.tags.find((tag) =>
    tag.includes('highlighted_pill'),
  );

  const savings =
    ((variantCompareAtPrice - variantPrice) * 100) / variantCompareAtPrice;

  return (
    <>
      <div
        className={`text-[14px] leading-[18px] ${
          badgeTag ? 'mb-[10px]' : 'mb-[30px]'
        } flex items-center flex-wrap`}
        data-price
      >
        <div className="flex items-center w-full">
          <div>
            <span
              role="price"
              data-variant-id={activeVariant?.id?.split('/')?.pop()}
              className={`py-[6px] inline-block mr-[10px] ${
                variantCompareAtPrice ? 'text-[#f082b3]' : ''
              }`}
            >
              {formatMoney({ amount: variantPrice }, true)}
            </span>
            {variantCompareAtPrice && (
              <>
                <del className="mr-[10px] py-[6px]">
                  {formatMoney({ amount: variantCompareAtPrice }, true)}
                </del>
                <span className="mr-[10px] text-[15px] font-medium rounded py-[4px] px-[6px] bg-grey-150">
                  {Math.floor(savings)}% Off
                </span>
              </>
            )}
          </div>
          <Rewards />
        </div>
        <Reviews id={activeProduct} />
      </div>
      {badgeTag ? (
        <div class="inline-block text-h6 py-[5px] mb-[14px] w-full font-bold text-[#f082b3]">
          {badgeTag.split('::')[1]}
        </div>
      ) : null}
    </>
  );
};

export default Price;
